export const initialChangedFilters = () => {
	return {
		changedRouteFilters: {
			numDays: false,
			landingIn: false,
			layoverIn: false,
			layoverDuration: false,
			fltNo: false,
			sectors: false,
			deadHeadFlight: false,
			redEyeFlights: false
		},
		changedDateFilter: {
			dates: false,
			onDuty: false,
			offDuty: false,
			tafb: false,
		},
		changedCpeFilter: {
			expenses: false,
			credit: false,
			hoursPerDay: false,
			efficiency: false,
			dayCredit: false,
			nightCredit: false,
			dhCredit: false,
			oseas: false,
		},
		changedOthersFilter: {
			occurs: false,
			pairType: false,
		},
	}
}

export const stateMapper = new Map();
    stateMapper.set('credit', 'credit');
    stateMapper.set('hoursPerDay', 'hoursPerDay');
    stateMapper.set('efficiency', 'eff');
    stateMapper.set('dayCredit', 'daycredit');
    stateMapper.set('nightCredit', 'nightcredit');
    stateMapper.set('dhCredit', 'dhCredit');
    stateMapper.set('oseas', 'overseasCredit');
    stateMapper.set('expenses', 'expenses');
    stateMapper.set('onDuty', 'onduty');
    stateMapper.set('offDuty', 'offduty');
    stateMapper.set('tafb', 'tafb');

    const sliderDefaultState = {
        credit: { range:[0 ,0] },
        hoursPerDay: { range:[0 ,0] },
        dayCredit: { range:[0 ,0] },
        nightCredit: { range:[0 ,0] },
        dhCredit: { range:[0 ,0] },
        oseas: { range:[0 ,0] },
        efficiency: { range:[0 ,0] },
        onDuty: { range:[0 ,0] },
        offDuty: { range:[0 ,0] },
        tafb: { range:[0 ,0] }
      };

	  const sliderLayoverState = {
        layoverDuration: { range:[0 ,0] }
      };

export const getMinMax = (arr, customFunction: any = undefined) => {
    let min = customFunction ? arr.slice().sort(customFunction) : arr.slice().sort();
    if (!min[0]) {
        min[0] = 0;
    }
    if (!min[arr.length - 1]) {
        min[arr.length - 1] = 0;
    }
    return [min[0], min[arr.length - 1]];
}

export const appliedFilters = (pairingList, selectedFilters, setChangedFilters, changedFilters) => {

	if (!pairingList.length) {
        return;
      }

    let sortAsend = (a,b) => a > b ? 1 : b > a ? -1 : 0;
    let builtState = Object.keys(sliderDefaultState).map(key => ({[key]: sliderDefaultState[key].range = getMinMax(pairingList.map(f => f[stateMapper.get(key)]), sortAsend)}));
    let slidersRange = builtState.reduce((a,n) => {
      let tempKey = Object.keys(n)[0];
      let defaultObj = {range: n[tempKey]};
    return {...a, [tempKey]: defaultObj};
  },{} as any);

  	// Route Filters
	if (!selectedFilters.selectedRouteFilters.numDays.selected?.includes('All') && selectedFilters.selectedRouteFilters.numDays.selected?.length > 0) {
		changedFilters.changedRouteFilters.numDays = true;
	} else { changedFilters.changedRouteFilters.numDays = false; }

	if (!selectedFilters.selectedRouteFilters.landingIn.selected?.includes('All') && selectedFilters.selectedRouteFilters.landingIn.selected?.length > 0) {
		changedFilters.changedRouteFilters.landingIn = true;
	} else { changedFilters.changedRouteFilters.landingIn = false; }

	if (!selectedFilters.selectedRouteFilters.layoverIn.selected?.includes('All') && selectedFilters.selectedRouteFilters.layoverIn.selected?.length > 0) {
		changedFilters.changedRouteFilters.layoverIn = true;
	} else { changedFilters.changedRouteFilters.layoverIn = false; }

	if (!selectedFilters.selectedRouteFilters.sectors.selected?.includes('All') && selectedFilters.selectedRouteFilters.sectors.selected?.length > 0) {
		changedFilters.changedRouteFilters.sectors = true;
	} else { changedFilters.changedRouteFilters.sectors = false; }

	let builtStateLayover = Object.keys(sliderLayoverState).map(key => ({ [key]: sliderLayoverState[key].range = getMinMax(pairingList.map(p => p.flightSegments.map(f => f.layOver)).flat(), sortAsend) }));
	let slidersRangeLayover = builtStateLayover.reduce((a, n) => {
		let tempKey = Object.keys(n)[0];
		let defaultObj = { range: n[tempKey] };
		return { ...a, [tempKey]: defaultObj };
	}, {} as any);

	if ((selectedFilters.selectedRouteFilters.layoverDuration.selected[0] === -1 && selectedFilters.selectedRouteFilters.layoverDuration.selected[1] === -1) ||
		(selectedFilters.selectedRouteFilters.layoverDuration.selected[0] === slidersRangeLayover.layoverDuration.range[0] &&
			selectedFilters.selectedRouteFilters.layoverDuration.selected[1] === slidersRangeLayover.layoverDuration.range[1])) {
		changedFilters.changedRouteFilters.layoverDuration = false;
	} else { changedFilters.changedRouteFilters.layoverDuration = true; }

	if (selectedFilters.selectedRouteFilters.fltNo) {
		changedFilters.changedRouteFilters.fltNo = true;
	} else { changedFilters.changedRouteFilters.fltNo = false; }

	if (!selectedFilters.selectedRouteFilters.redEyeFlights) {
		changedFilters.changedRouteFilters.redEyeFlights = true;
	} else { changedFilters.changedRouteFilters.redEyeFlights = false; }

	if (!selectedFilters.selectedRouteFilters.deadHeadFlight) {
		changedFilters.changedRouteFilters.deadHeadFlight = true;
	} else { changedFilters.changedRouteFilters.deadHeadFlight = false; }

	// AppCalendar Filter
	if (selectedFilters.selectedDateFilter.dates.length === 0) {
		changedFilters.changedDateFilter.dates = false
	} else { changedFilters.changedDateFilter.dates = true }

	if ((selectedFilters.selectedDateFilter.onDuty.selected[0] === -1 && selectedFilters.selectedDateFilter.onDuty.selected[1] === -1) || 
        (selectedFilters.selectedDateFilter.onDuty.selected[0] === slidersRange.onDuty.range[0] && 
        selectedFilters.selectedDateFilter.onDuty.selected[1] === slidersRange.onDuty.range[1])) {
		    changedFilters.changedDateFilter.onDuty = false;
	} else { changedFilters.changedDateFilter.onDuty = true; }

	if ((selectedFilters.selectedDateFilter.offDuty.selected[0] === -1 && selectedFilters.selectedDateFilter.offDuty.selected[1] === -1) || 
        (selectedFilters.selectedDateFilter.offDuty.selected[0] === slidersRange.offDuty.range[0] && 
        selectedFilters.selectedDateFilter.offDuty.selected[1] === slidersRange.offDuty.range[1])) {
		    changedFilters.changedDateFilter.offDuty = false;
	} else { changedFilters.changedDateFilter.offDuty = true;}

	if ((selectedFilters.selectedDateFilter.tafb.selected[0] === -1 && selectedFilters.selectedDateFilter.tafb.selected[1] === -1) || 
        (selectedFilters.selectedDateFilter.tafb.selected[0] === slidersRange.tafb.range[0] && 
        selectedFilters.selectedDateFilter.tafb.selected[1] === slidersRange.tafb.range[1])) {
		    changedFilters.changedDateFilter.tafb = false;
	} else { changedFilters.changedDateFilter.tafb = true; }

	// CPE Filters	
	if ((selectedFilters.selectedCpeFilter.credit.selected[0] === -1 && selectedFilters.selectedCpeFilter.credit.selected[1] === -1) ||
        (selectedFilters.selectedCpeFilter.credit.selected[0] === slidersRange.credit.range[0] && 
        selectedFilters.selectedCpeFilter.credit.selected[1] === slidersRange.credit.range[1]) ) {
		changedFilters.changedCpeFilter.credit = false;
	} else { changedFilters.changedCpeFilter.credit = true; }

	if ((selectedFilters.selectedCpeFilter.hoursPerDay.selected[0] === -1 && selectedFilters.selectedCpeFilter.hoursPerDay.selected[1] === -1) || 
        (selectedFilters.selectedCpeFilter.hoursPerDay.selected[0] === slidersRange.hoursPerDay.range[0] && 
        selectedFilters.selectedCpeFilter.hoursPerDay.selected[1] === slidersRange.hoursPerDay.range[1])) {
		changedFilters.changedCpeFilter.hoursPerDay = false;
	} else { changedFilters.changedCpeFilter.hoursPerDay = true; }

	if ((selectedFilters.selectedCpeFilter.efficiency.selected[0] === -1 && selectedFilters.selectedCpeFilter.efficiency.selected[1] === -1) || 
        (selectedFilters.selectedCpeFilter.efficiency.selected[0] === slidersRange.efficiency.range[0] && 
        selectedFilters.selectedCpeFilter.efficiency.selected[1] === slidersRange.efficiency.range[1] ) ) {
		changedFilters.changedCpeFilter.efficiency = false;
	} else { changedFilters.changedCpeFilter.efficiency = true; }

	if ((selectedFilters.selectedCpeFilter.dayCredit.selected[0] === -1 && selectedFilters.selectedCpeFilter.dayCredit.selected[1] === -1) || 
        (selectedFilters.selectedCpeFilter.dayCredit.selected[0] === slidersRange.dayCredit.range[0] && 
        selectedFilters.selectedCpeFilter.dayCredit.selected[1] === slidersRange.dayCredit.range[1]) ) {
		changedFilters.changedCpeFilter.dayCredit = false; 
	} else { changedFilters.changedCpeFilter.dayCredit = true; }

	if ((selectedFilters.selectedCpeFilter.nightCredit.selected[0] === -1 && selectedFilters.selectedCpeFilter.nightCredit.selected[1] === -1) || 
        (selectedFilters.selectedCpeFilter.nightCredit.selected[0] === slidersRange.nightCredit.range[0] && 
            selectedFilters.selectedCpeFilter.nightCredit.selected[1] === slidersRange.nightCredit.range[1]) ) {
		changedFilters.changedCpeFilter.nightCredit = false;
	} else { changedFilters.changedCpeFilter.nightCredit = true; }

	if ((selectedFilters.selectedCpeFilter.dhCredit.selected[0] === -1 && selectedFilters.selectedCpeFilter.dhCredit.selected[1] === -1) || 
        (selectedFilters.selectedCpeFilter.dhCredit.selected[0] === slidersRange.dhCredit.range[0] && 
            selectedFilters.selectedCpeFilter.dhCredit.selected[1] === slidersRange.dhCredit.range[1])) {
		changedFilters.changedCpeFilter.dhCredit = false;
	} else { changedFilters.changedCpeFilter.dhCredit = true; }

	if ((selectedFilters.selectedCpeFilter.oseas.selected[0] === -1 && selectedFilters.selectedCpeFilter.oseas.selected[1] === -1) || 
        (selectedFilters.selectedCpeFilter.oseas.selected[0] === slidersRange.oseas.range[0] && 
            selectedFilters.selectedCpeFilter.oseas.selected[1] === slidersRange.oseas.range[1])) {
		changedFilters.changedCpeFilter.oseas = false;
	} else { changedFilters.changedCpeFilter.oseas = true; }

	if (selectedFilters.selectedCpeFilter.expenses['filter'].toLowerCase() !== 'all') {
		changedFilters.changedCpeFilter.expenses = true;
	} else { changedFilters.changedCpeFilter.expenses = false; }

	// Others Filter
	if (!selectedFilters.selectedOthersFilter.occurs.selected?.includes('All') && selectedFilters.selectedOthersFilter.occurs.selected?.length > 0) {
		changedFilters.changedOthersFilter.occurs = true;
	} else { changedFilters.changedOthersFilter.occurs = false; }

	if (!selectedFilters.selectedOthersFilter.pairType.selected?.includes('All') && selectedFilters.selectedOthersFilter.pairType.selected?.length > 0) {
		changedFilters.changedOthersFilter.pairType = true;
	} else { changedFilters.changedOthersFilter.pairType = false; }

	setChangedFilters((prev) => {
		return {
			...prev,
			...changedFilters
		}
	})
}
